import { useState, useEffect } from "react";
import { LoadingEnum } from "../../../types/utility/async.js";
const cachedLinkStatuses = {};
function getLinkNode(href) {
  const node = document.querySelector(`link[href="${href}"]`);
  const status = node == null ? void 0 : node.getAttribute("data-status");
  return {
    node,
    status
  };
}
function useLink(href, options) {
  const [status, setStatus] = useState(() => {
    if (!href || (options == null ? void 0 : options.shouldPreventLoad)) {
      return LoadingEnum.Idle;
    }
    if (typeof window === "undefined") {
      return LoadingEnum.Loading;
    }
    return cachedLinkStatuses[href] ?? LoadingEnum.Loading;
  });
  useEffect(() => {
    if (!href || (options == null ? void 0 : options.shouldPreventLoad)) {
      return;
    }
    const cachedLinkStatus = cachedLinkStatuses[href];
    if (cachedLinkStatus === LoadingEnum.Ready || cachedLinkStatus === LoadingEnum.Error) {
      setStatus(cachedLinkStatus);
      return;
    }
    const link = getLinkNode(href);
    let linkNode = link.node;
    if (!linkNode) {
      linkNode = document.createElement("link");
      linkNode.href = href;
      linkNode.rel = (options == null ? void 0 : options.rel) || "stylesheet";
      linkNode.media = (options == null ? void 0 : options.media) || "all";
      linkNode.setAttribute("data-status", "loading");
      document.head.appendChild(linkNode);
      const setAttributeFromEvent = (event) => {
        const linkStatus = event.type === "load" ? LoadingEnum.Ready : LoadingEnum.Error;
        linkNode == null ? void 0 : linkNode.setAttribute("data-status", linkStatus);
      };
      linkNode.addEventListener("load", setAttributeFromEvent);
      linkNode.addEventListener("error", setAttributeFromEvent);
    } else {
      setStatus(link.status ?? cachedLinkStatus ?? LoadingEnum.Loading);
    }
    const setStateFromEvent = (event) => {
      const newStatus = event.type === "load" ? LoadingEnum.Ready : LoadingEnum.Error;
      setStatus(newStatus);
      cachedLinkStatuses[href] = newStatus;
    };
    linkNode.addEventListener("load", setStateFromEvent);
    linkNode.addEventListener("error", setStateFromEvent);
    return () => {
      if (linkNode) {
        linkNode.removeEventListener("load", setStateFromEvent);
        linkNode.removeEventListener("error", setStateFromEvent);
      }
      if (linkNode && (options == null ? void 0 : options.removeOnUnmount)) {
        linkNode.remove();
      }
    };
  }, [href, options]);
  return status;
}
export {
  useLink
};
